import ReactDOM from 'react-dom/client'
import "./styles/tailwind.css";
import App from "./App";
import AppErrorBoundary from "./components/ui/AppErrorBoundary";
import * as serviceWorker from "./serviceWorker";
import React from 'react';
import { ClerkProvider } from '@clerk/clerk-react';
// hides Clerk's own "Delete account" in the Clerk components Bearri renders (cosmetic: see clerkAppearance.ts for the
// real control, which is per-user at Clerk), and the development instance's "Development mode" notice
import { CLERK_APPEARANCE } from './components/auth/clerkAppearance';
// Clerk's words in Bearri's: the invite-only errors and the "this invite link doesn't work" card
import { BEARRI_CLERK_LOCALIZATION } from './components/auth/clerkLocalization';
import { captureArrivalSource } from './services/waitlistService';

const PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;
if (!PUBLISHABLE_KEY) {
  throw new Error("Missing Clerk Publishable Key");
}

// Where this visit came from (utm_* tags, an outside referrer), kept in this tab for the waitlist form. Read here,
// on the first page opened, because by the time someone reaches /waitlist the referrer is bearri.co itself.
captureArrivalSource();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {/* Bearri's own pages for every auth door, so Clerk never sends anyone to its hosted (development) pages:
        /login signs in, /invite is where an invite email lands, /waitlist is the way in for everyone else. */}
    <ClerkProvider
      publishableKey={PUBLISHABLE_KEY}
      afterSignOutUrl="/"
      afterSignUpUrl="/app/dashboard"
      signInUrl="/login"
      signUpUrl="/invite"
      waitlistUrl="/waitlist"
      // Clerk's "Email support" buttons (a refused invite, "Having trouble?") would otherwise mail support@ Clerk's
      // own development domain
      supportEmail="support@bearri.co"
      localization={BEARRI_CLERK_LOCALIZATION}
      appearance={CLERK_APPEARANCE}
    >
      <AppErrorBoundary>
        <App />
      </AppErrorBoundary>
    </ClerkProvider>
  </React.StrictMode>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
